const toggleDropdown = (e) => {
  const dropdown = e.target.closest('.dropdown')
  if (!dropdown) return

  const menu = dropdown.querySelector('.dropdown-menu')
  const toggle = dropdown.querySelector('[data-toggle="dropdown"]')

  setTimeout(
    () => {
      const shouldOpen = e.type !== 'click' && dropdown.matches(':hover')
      dropdown.classList.toggle('show', shouldOpen)
      menu.classList.toggle('show', shouldOpen)
      if (toggle) toggle.setAttribute('aria-expanded', shouldOpen)
    },
    e.type === 'mouseleave' ? 10 : 0
  )
}

const handleDropdownClick = (e) => {
  const toggle = e.currentTarget
  const parent = toggle.closest('.dropdown')
  if (!parent) return

  if (parent.classList.contains('show')) {
    window.location.href = toggle.getAttribute('href')
  } else {
    e.preventDefault()
    parent.classList.add('show')
    toggle.setAttribute('aria-expanded', 'true')
  }
}

const handleSubmenuHover = (submenu) => {
  const submenuMenu = submenu.querySelector('.dropdown-menu')
  submenuMenu.classList.remove('open-left')

  const rect = submenuMenu.getBoundingClientRect()
  if (rect.right > window.innerWidth) {
    submenu.classList.add('open-left')
  }
}

export const initMenu = () => {
  document.querySelectorAll('.main-menu .dropdown').forEach((dropdown) => {
    dropdown.addEventListener('mouseenter', toggleDropdown)
    dropdown.addEventListener('mouseleave', toggleDropdown)
  })

  document.querySelectorAll('.main-menu .dropdown-toggle').forEach((toggle) => {
    toggle.addEventListener('click', handleDropdownClick)
  })

  document.querySelectorAll('.main-menu .dropdown-submenu').forEach((submenu) => {
    const menu = submenu.querySelector('.dropdown-menu')

    submenu.addEventListener('mouseenter', () => {
      submenu.classList.add('show')
      if (menu) menu.classList.add('show')
      handleSubmenuHover(submenu)
    })

    submenu.addEventListener('mouseleave', () => {
      submenu.classList.remove('show')
      if (menu) menu.classList.remove('show')
    })
  })
}
